import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../../../pictures/图片1.png';
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "notice"
};
const _hoisted_5 = {
  class: "sort"
};
const _hoisted_6 = {
  class: "part"
};
const _hoisted_7 = {
  class: "part"
};
const _hoisted_8 = {
  class: "part"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_swipe, {
    class: "my-swipe",
    autoplay: 3000,
    "lazy-render": ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, image => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: image
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("img", {
          class: "img",
          style: {
            "object-fit": "fill"
          },
          src: _imports_0
        }, null, -1)])),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_swipe, {
    style: {
      "height": "60px"
    },
    class: "my-swipe",
    autoplay: 3000,
    "indicator-color": "white",
    vertical: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgs, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title) + " ", 1), _createVNode(_component_router_link, {
          to: "/noticedetail",
          style: {
            "font-size": "15px"
          }
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 点击查看 >>")])),
          _: 1
        })]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "title"
  }, "个人信息", -1)), _createVNode(_component_van_grid, {
    "column-num": 3
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: "contact-o",
      text: "基本信息",
      to: "/baseinfo"
    }), _createVNode(_component_van_grid_item, {
      icon: "bill-o",
      text: "奖助贷信息",
      to: "/rewardinfo"
    }), _createVNode(_component_van_grid_item, {
      icon: "flower-o",
      text: "宿舍信息",
      to: "/stayinfo"
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "title"
  }, "校园生活", -1)), _createVNode(_component_van_grid, {
    "column-num": 3
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: "star-o",
      text: "成绩查询",
      to: "/gradeinfo"
    }), _createVNode(_component_van_grid_item, {
      icon: "smile-comment-o",
      text: "新闻及通知",
      to: "/newslist"
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "title"
  }, "校园管理", -1)), _createVNode(_component_van_grid, {
    "column-num": 3
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: "underway-o",
      text: "发起请假",
      to: "/leave"
    }), _createVNode(_component_van_grid_item, {
      icon: "records-o",
      text: "请假记录",
      to: "/leaverecord"
    })]),
    _: 1
  })])])]), _createVNode(_component_Footer)]);
}